import ProjectTemplate from '../../components/common/ProjectTemplate';
import TowerEditorContainer from '../../components/tower/TowerEditorContainer';
import TowerWriteActionButtonsContainer from '../../components/tower/TowerWriteActionButtonsContainer';

const TowerWritePage = () => {
    return (
        <ProjectTemplate>
            <TowerEditorContainer />
            <TowerWriteActionButtonsContainer />
        </ProjectTemplate>
    );
};

export default TowerWritePage;
